// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"38":"d7d6b2de","49":"10b4c075","328":"f48376d8","481":"83a8afff","861":"5bc6ba27"}[chunkId] + ".chunk.css";
};